import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { NoveltyCheckReportContext } from '../novelty-check-report-context';
import { NoveltyCheckReportState } from '../novelty-check-report-state';
import { Logger } from '@patsnap/tahiti-core';
import { NoveltyCheckTaskStep } from '@/domains/novelty-check-report/enums';
import { NoveltyCheckTaskStatusModel } from '@/domains/novelty-check-report/models/novelty-check-task-status-model';
import { NoveltyCheckReportTitleService, RetrievalElementsService, TechFeaturesService } from '../../retrieval-result-report-service';
import { ComplexRetrievalService } from '../../complex-retrieval-service';
import { SummaryTechFeaturesService } from '../../summary-tech-features-service';
import { NoveltyCheckTaskStatusService } from '../../task-status-service';

@injectable()
export class GenerateFeatureCompareTableState implements NoveltyCheckReportState {
    constructor(
        @inject(Logger)
        private readonly _logger: Logger,
        @inject(NoveltyCheckTaskStatusModel)
        private readonly _noveltyCheckTaskStatusModel: NoveltyCheckTaskStatusModel,
        @inject(SummaryTechFeaturesService)
        private readonly _summaryTechFeatureService: SummaryTechFeaturesService,
        @inject(NoveltyCheckReportTitleService)
        private readonly _noveltyCheckReportTitleService: NoveltyCheckReportTitleService,
        @inject(TechFeaturesService)
        private readonly _techFeaturesService: TechFeaturesService,
        @inject(ComplexRetrievalService)
        private readonly _complexRetrievalService: ComplexRetrievalService,
        @inject(RetrievalElementsService)
        private readonly _retrievalElementsService: RetrievalElementsService,
        @inject(NoveltyCheckTaskStatusService)
        private readonly _noveltyCheckTaskStatusService: NoveltyCheckTaskStatusService,
    ) { }

    async enter(): Promise<void> {
        await this._noveltyCheckTaskStatusService.pullTaskStatus();
        // 进入<生成特征对比表>状态的逻辑
        this._logger.info('进入<生成特征对比表>状态');
        this._switchTaskStep(NoveltyCheckTaskStep.GENERATE_FEATURE_COMPARE_TABLE);
        await Promise.all([
            // this._summaryTechFeatureService.pullSummary(),
            // 获取新颖性报告名称
            // this._noveltyCheckReportTitleService.pullNoveltyCheckReportTitle(),
            // 获取技术特征
            // this._techFeaturesService.pullTechFeatures(),
            // 获取搜索结果
            // this._complexRetrievalService.search(),
            // 获取检索要素
            // this._retrievalElementsService.pullRetrievalElements(),
        ]);
    }

    async handleNext(context: NoveltyCheckReportContext): Promise<void> {
        // 从<生成特征对比表>状态进入报告生成状态
        const resultState = context.getState(NoveltyCheckTaskStep.REPORT_CREATED);
        await context.transitionTo(resultState);
    }

    async handlePrevious(context: NoveltyCheckReportContext): Promise<void> {
        // 返回专利确认状态
        const patentConfirmState = context.getState(NoveltyCheckTaskStep.PATENT_CONFIRM);
        await context.transitionTo(patentConfirmState);
    }

    private _switchTaskStep(step: NoveltyCheckTaskStep) {
        this._noveltyCheckTaskStatusModel.update(state => {
            state.taskStep = step;
            return state;
        });
    }
}
